import { render } from "./IletsSlider2.vue?vue&type=template&id=b2d62ee6&scoped=true"
import script from "./IletsSlider2.vue?vue&type=script&lang=js"
export * from "./IletsSlider2.vue?vue&type=script&lang=js"

import "./IletsSlider2.vue?vue&type=style&index=0&id=b2d62ee6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2d62ee6"]])

export default __exports__